export default __webpack_public_path__ + "static/media/CodersCruxRegular.18e6cf59.woff2";